import 'react-perfect-scrollbar/dist/css/styles.css';
import React from 'react';
import {useRoutes} from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from './components/GlobalStyles';
import theme from './theme';
import routes from './routes';
import {AlertProvider} from "./contexts/AlertContext";
import {ConfirmProvider} from "material-ui-confirm";
import {MsalProvider} from "@azure/msal-react";

const App = ({pca}) => {
	const routing = useRoutes(routes);

	return (
        <MsalProvider instance={pca}>
            <ThemeProvider theme={theme}>
                <AlertProvider>
                    <ConfirmProvider>
                        <GlobalStyles />
                        {routing}
                    </ConfirmProvider>
                </AlertProvider>
            </ThemeProvider>
        </MsalProvider>
	);
};

export default App;
